import { useCallback } from "react";
import NiceModal from "@ebay/nice-modal-react";
import { useTranslate } from "hooks";
import * as identify from "utils/treeUtils";

import { isDeleteModalDisabled } from "components/ProjectTree/utils/skipDeleteModal";
import { ConfirmationModal } from "components/_Modals/ConfirmationModal";

const FolderDeleteFlag = "folderDeleteModal";
const ProductDeleteFlag = "folderDeleteModal";

export const useDeleteConfirmationCheck = () => {
  const translate = useTranslate();

  const deleteConfirmationCheck = useCallback(
    (node, callback = () => {}) => {
      const flag = identify.isAnyProduct(node.data)
        ? ProductDeleteFlag
        : FolderDeleteFlag;
      const skipModal = isDeleteModalDisabled(flag);
      if (skipModal) {
        callback();
        return;
      }
      const hasChildren =
        Array.isArray(node.children) && node.children.length > 0;
      NiceModal.show(ConfirmationModal, {
        submitBtnText: hasChildren
          ? translate("PROJECT_ITEM_DELETE_MODAL_SUBMIT_BTN_TEXT_PLURAL")
          : translate("PROJECT_ITEM_DELETE_MODAL_SUBMIT_BTN_TEXT"),
        title: hasChildren
          ? translate("PROJECT_ITEM_DELETE_MODAL_TITLE_PLURAL")
          : translate("PROJECT_ITEM_DELETE_MODAL_TITLE"),
        alertText: `${translate(
          hasChildren
            ? "PROJECT_ITEM_DELETE_MODAL_BODY_PLURAL_WITH_TITLE_PARAM"
            : "PROJECT_ITEM_DELETE_MODAL_BODY_SINGULAR_WITH_TITLE_PARAM",
          [node.data.title || node.data.productName || node.data.folderName],
        )} ${translate("PROJECT_ITEM_DELETE_MODAL_BODY_TEXT_CAUTION")}`,
        withDisableCheckbox: true,
        modalToDisable: "folderDeleteModal",
        onConfirm: () => callback(),
      });
    },
    [translate],
  );

  return deleteConfirmationCheck;
};
